import $ from 'jquery'
import Component from "../models/Component"

export default class LavoraConNoi extends Component {
    constructor(element, context) {
        super(element, context);
        $(() => {
            const $root = $(element);
            const $selectAzienda = $root.find('.js-filtro-azienda');
            const $selectSito = $root.find('.js-filtro-sito');
            const $cards = $root.find('.js-card-posizione');
            const $nessunRisultato = $root.find('.js-nessun-risultato');
            const $risultati = $root.find('.js-risultati-posizioni');
            const $filtriExtra = $root.find('.js-filtri-extra');
            const $resetFiltri = $root.find('.js-reset-filtri');

            // Opzioni "sito" originali, per poter ripristinare il filtro cascata azienda -> sito
            const sitoOptionsOriginali = $selectSito.find('option').clone();

            function aggiornaOpzioniSito() {
                const aziendaSelezionata = $selectAzienda.val();
                const sitoAttuale = $selectSito.val();

                $selectSito.empty();
                sitoOptionsOriginali.each(function () {
                    const $opt = $(this);

                    // Placeholder ("Scegliere un sito"): sempre presente.
                    if (!$opt.val()) {
                        $selectSito.append($opt.clone());
                        return;
                    }

                    // Un sito senza azienda assegnata non appartiene a nessun
                    // filtro: va mostrato solo quando non c'e' azienda scelta.
                    const aziendaOpzione = $opt.attr('data-azienda') || '';
                    if (!aziendaSelezionata || aziendaOpzione === aziendaSelezionata) {
                        $selectSito.append($opt.clone());
                    }
                });

                // Se il sito selezionato non è più tra le opzioni disponibili, resetta.
                if ($selectSito.find('option[value="' + sitoAttuale + '"]').length === 0) {
                    $selectSito.val('');
                } else {
                    $selectSito.val(sitoAttuale);
                }
            }

            function filtraRisultati() {
                const aziendaSelezionata = $selectAzienda.val();
                const sitoSelezionato = $selectSito.val();
                let visibili = 0;

                $cards.each(function () {
                    const $card = $(this);
                    const matchAzienda = !aziendaSelezionata || $card.attr('data-azienda') === aziendaSelezionata;
                    const matchSito = !sitoSelezionato || $card.attr('data-sito') === sitoSelezionato;
                    const visibile = matchAzienda && matchSito;
                    $card.toggle(visibile);
                    if (visibile) visibili++;
                });

                $nessunRisultato.toggleClass('hidden', visibili > 0);
                $risultati.toggleClass('hidden', visibili === 0);
            }

            // Confronto tra nome sito e nome azienda: minuscole e spazi normalizzati
            // (i titoli inseriti da backend contengono spazi unificatori).
            function normalizza(testo) {
                return (testo || '').toString().replace(/\s+/g, ' ').trim().toLowerCase();
            }

            // Il select "Sito" serve solo se aggiunge una scelta: con un unico sito
            // omonimo dell'azienda sarebbe un passaggio in piu' che non filtra nulla.
            function sitoUtile() {
                const $opzioni = $selectSito.find('option').filter(function () {
                    return !!$(this).val();
                });

                if ($opzioni.length === 0) {
                    return false;
                }

                if ($opzioni.length > 1) {
                    return true;
                }

                const nomeAzienda = normalizza($selectAzienda.find('option:selected').text());

                return normalizza($opzioni.first().text()) !== nomeAzienda;
            }

            function aggiornaVisibilitaFiltriExtra() {
                const aziendaScelta = !!$selectAzienda.val();
                const mostraSito = aziendaScelta && sitoUtile();

                // Select nascosto: il filtro per sito va azzerato, altrimenti
                // resterebbe attivo un criterio non piu' visibile.
                if (!mostraSito && $selectSito.val()) {
                    $selectSito.val('');
                }

                $filtriExtra.toggleClass('hidden', !mostraSito);
                $resetFiltri.toggleClass('hidden', !aziendaScelta);
            }

            $selectAzienda.on('change', function () {
                aggiornaOpzioniSito();
                aggiornaVisibilitaFiltriExtra();
                filtraRisultati();
            });

            $selectSito.on('change', filtraRisultati);

            $resetFiltri.on('click', function () {
                $selectAzienda.val('');
                $selectSito.val('');
                aggiornaOpzioniSito();
                aggiornaVisibilitaFiltriExtra();
                filtraRisultati();
            });

            // Form "Candidatura spontanea": cascata azienda -> sito e disclaimer
            // privacy per azienda. Dati calcolati dal PHP e letti da un solo
            // elemento, cosi' elenchi e varianti non possono divergere.
            // Nella pagina singola posizione la variante la decide il PHP.
            const $datiCandidatura = $('.js-dati-candidatura');

            if ($datiCandidatura.length) {
                const $selectAziendaForm = $('select[name="azienda_interesse"]');
                const $selectSitoForm = $('select[name="sito_interesse"]');
                const $campoSito = $selectSitoForm.closest('.js-campo-sito');
                const $disclaimers = $('.js-disclaimer-privacy');

                function leggiDati(attributo) {
                    try {
                        return JSON.parse($datiCandidatura.attr(attributo) || '{}');
                    } catch (e) {
                        return {};
                    }
                }

                const variantePerAzienda = leggiDati('data-varianti');
                const sitiPerAzienda = leggiDati('data-siti');

                // Opzioni originali del select "sito": servono per ricostruirlo
                // ad ogni cambio di azienda.
                const sitoFormOptionsOriginali = $selectSitoForm.find('option').clone();

                function aziendaScelta() {
                    return ($selectAziendaForm.val() || '').toString().trim();
                }

                function aggiornaDisclaimer() {
                    const variante = variantePerAzienda[aziendaScelta()] || 'default';

                    $disclaimers.each(function () {
                        const $el = $(this);
                        $el.toggleClass('hidden', $el.attr('data-variante') !== variante);
                    });
                }

                function aggiornaSitiForm() {
                    const azienda = aziendaScelta();
                    const siti = sitiPerAzienda[azienda] || [];
                    const sitoAttuale = $selectSitoForm.val();

                    $selectSitoForm.empty();
                    sitoFormOptionsOriginali.each(function (indice) {
                        const $opt = $(this);

                        // Placeholder ("Scegliere un sito"): sempre presente.
                        // Va riconosciuto per posizione e non per valore vuoto:
                        // senza "first_as_label" CF7 gli assegna come value il
                        // testo stesso dell'opzione.
                        if (indice === 0 || !$opt.val()) {
                            $selectSitoForm.append($opt.clone());
                            return;
                        }

                        if (azienda && siti.indexOf($opt.val()) !== -1) {
                            $selectSitoForm.append($opt.clone());
                        }
                    });

                    const valorePlaceholder = $selectSitoForm.find('option').first().val();
                    const disponibile = $selectSitoForm.find('option').filter(function () {
                        return $(this).val() === sitoAttuale;
                    }).length > 0;

                    $selectSitoForm.val(disponibile ? sitoAttuale : valorePlaceholder);

                    // Stessa regola dei filtri delle posizioni aperte: il campo
                    // serve solo se aggiunge una scelta. Con un unico sito
                    // omonimo dell'azienda sarebbe un passaggio a vuoto.
                    const utile = siti.length > 1
                        || (siti.length === 1 && normalizza(siti[0]) !== normalizza(azienda));

                    if (!utile) {
                        $selectSitoForm.val(valorePlaceholder);
                    }

                    $campoSito.toggleClass('hidden', !azienda || !utile);
                }

                $selectAziendaForm.on('change', function () {
                    aggiornaSitiForm();
                    aggiornaDisclaimer();
                });

                aggiornaSitiForm();
                aggiornaDisclaimer();
            }

            // Campi upload custom (Allega CV / lettera di presentazione) nel form CF7
            // (sia sezione "Candidatura spontanea" del listing, sia pagina singola posizione).
            const $uploadBoxes = $('.upload-box');

            $uploadBoxes.each(function () {
                const $box = $(this);
                const $input = $box.find('input[type="file"]');
                if (!$input.length) return;

                function aggiornaNomeFile(fileList) {
                    $box.find('.upload-box-filename').remove();
                    if (fileList && fileList.length) {
                        $box.append('<span class="upload-box-filename">' + fileList[0].name + '</span>');
                    }
                }

                $input.on('change', function () {
                    aggiornaNomeFile(this.files);
                });

                $box.on('dragover dragenter', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $box.addClass('is-dragover');
                });

                $box.on('dragleave dragend', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $box.removeClass('is-dragover');
                });

                $box.on('drop', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $box.removeClass('is-dragover');
                    const dt = e.originalEvent.dataTransfer;
                    if (dt && dt.files && dt.files.length) {
                        $input[0].files = dt.files;
                        aggiornaNomeFile(dt.files);
                    }
                });
            });
        });
    }
}
